import MultiInput from './MultiInput'; // export {MultiInputValidated} from './MultiInput';

export default MultiInput;